<template>
  <div class="mysetup">
    <div class="mysetup_center">
      <el-menu
        :default-active="activeIndex"
        background-color="#1d4434"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1"> <span class="tabcolor">资料设置</span> </el-menu-item>
        <el-menu-item index="2"> <span class="tabcolor">账号设置</span> </el-menu-item>
      </el-menu>
      <div class="ziliao_setup" v-show="activeIndex == 1">
        <div v-if="form == null"></div>
        <el-form
          v-else
          ref="form"
          :rules="rulesform"
          :model="form"
          label-width="120px"
          inline
        >
          <h4>基础信息</h4>
          <el-col :span="24">
            <el-form-item label="头像">
              <userAvatar :user="form" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="姓名" prop="nickName">
              <span>{{ form.nickName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="性别">
              <el-radio-group v-model="form.sex">
                <el-radio label="0">男</el-radio>
                <el-radio label="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学号" prop="studentNum">
              <span>{{ form.studentNum }}</span>
              <el-tooltip placement="top">
                <div
                  slot="content"
                  style="text-align: center; line-height: 1.5; letter-spacing: 2px"
                >
                  操作提示<br />学号默认为系统登录账号<br />学号后六位为系统登录密码
                </div>
                <i style="color: #1d4434" class="el-icon-question phtonicons"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="email">
              <el-input placeholder="请输入电子邮箱" v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phonenumber">
              <span>{{ form.phonenumber }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="通讯地址">
              <el-input
                style="width: 500px"
                type="textarea"
                :rows="5"
                resize="none"
                v-model="form.familyAddress"
                placeholder="请输入通讯地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <div>
            <h4>学业信息</h4>
            <el-col :span="24">
              <el-form-item label="专业" prop="subjectId">
                <el-select
                  @change="zychangeSel"
                  v-model="form.subjectId"
                  disabled
                  placeholder="请选择专业"
                >
                  <el-option
                    v-for="item in subjectList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="班级" prop="classId">
                <el-select v-model="form.classId" disabled placeholder="请选择班级">
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="学业状态" prop="studies">
                <el-select v-model="form.studies" placeholder="请选择学业状态">
                  <el-option
                    v-for="item in studiesList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    clearable
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <h4>实习就业</h4>
            <el-col :span="24">
              <el-form-item label="实习单位">
                <el-input
                  style="width: 217px"
                  type="text"
                  placeholder="请输入实习单位"
                  v-model="form.kindergartenName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="入职状态" prop="kindergartenName">
                <el-select v-model="form.entryStatus" placeholder="请选择入职状态">
                  <el-option
                    v-for="item in entryList"
                    :key="item.status"
                    :label="item.name"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
        <div class="onsubtns">
          <el-button @click="onSubmit('form')">保存</el-button>
        </div>
      </div>
      <div class="psw_setup" v-show="activeIndex == 2">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="当前登录账号">
            <div class="psw_p1">
              <p style="color: #1d4434" v-if="form && form.studentNum">
                学号 {{ form.studentNum }}
              </p>
              <p class="p2">学习记录以当前登录账号为准</p>
            </div>
          </el-form-item>
          <el-form-item label="修改密码">
            <p class="updatapsw" @click="updatashow = !updatashow">更改密码</p>
          </el-form-item>
          <transition name="el-zoom-in-top">
            <el-form-item v-show="updatashow" label="修改密码">
              <div class="updatapas_inpts">
                <el-form
                  :model="ruleFormPsw"
                  status-icon
                  :rules="rulespsw"
                  ref="ruleFormPsw"
                  class="demo-ruleForm"
                >
                  <el-form-item label="" prop="oldPassword">
                    <el-input
                      type="password"
                      v-model="ruleFormPsw.oldPassword"
                      placeholder="请输入旧密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="newPassword">
                    <el-input
                      type="password"
                      v-model="ruleFormPsw.newPassword"
                      placeholder="请输入新密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="querenpassw">
                    <el-input
                      type="password"
                      v-model="ruleFormPsw.querenpassw"
                      placeholder="请再次输入新密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="updatabtnAll">
                <el-button @click="resetForm('ruleFormPsw')">取消</el-button>
                <el-button class="btn2" @click="submitFormpsw('ruleFormPsw')" plain
                  >确定</el-button
                >
              </div>
            </el-form-item>
          </transition>
          <el-divider></el-divider>
        </el-form>
        <div class="loginUp">
          <el-button class="elbtns" @click="handleLogout">退出登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfos, listSubject, listClass, updatePwd, updateInfo } from "@/api/mysetup";
import { getToken } from "@/utils/auth";
import userAvatar from "../components/Avatarupload/userAvatar.vue";
export default {
  name: "mysetup",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        if (this.ruleFormPsw.oldPassword !== "") {
          this.$refs.ruleFormPsw.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value !== this.ruleFormPsw.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkRegNo = (rule, value, callback) => {
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 ",
      };
      var tip = "";
      var pass = true;

      var patt1 = new RegExp(
        "(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)"
      );
      if (value == "") {
        pass = true;
      } else if (!patt1.test(value)) {
        callback(new Error("身份证号格式错误"));
        pass = false;
      } else if (!city[value.substr(0, 2)]) {
        callback(new Error("地址编码错误"));
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (value.length == 18) {
          value = value.split("");
          //∑(ai×Wi)(mod 11)
          //加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          //校验位
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = value[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != value[17]) {
            callback(new Error("身份证号码错误"));
            pass = false;
          }
        }
      }
      if (pass) {
        callback();
      }
    };
    return {
      activeIndex: "1",
      form: null,
      rulesform: {
        // email: [
        //   { required: true, message: "请输入email", trigger: "blur" },
        //   { type: "email", message: "请输入正确的邮箱地址", trigger: ["blur", "change"] },
        // ],
        // idCard: [
        //   { required: true, message: "请输入身份证号", trigger: "blur" },
        //   {
        //     validator: checkRegNo,
        //     message: "请输入正确的身份证号",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // subjectId: [{ required: true, message: "请选择专业", trigger: "change" }],
        // classId: [{ required: true, message: "请选择班级", trigger: "change" }],
      },
      subjectList: [], //专业列表
      classList: [], //班级
      studiesList: [
        { value: 0, label: "在学" },
        { value: 1, label: "毕业" },
      ],
      entryList: [
        {
          status: 0,
          name: "实习",
        },
        {
          status: 1,
          name: "就业",
        },
      ],
      updatashow: false,
      ruleFormPsw: {
        oldPassword: "",
        newPassword: "",
        querenpassw: "",
      },
      querenpassw: "",
      rulespsw: {
        oldPassword: [{ required: true, validator: validatePass, trigger: "blur" }],
        newPassword: [{ required: true, validator: validatePass, trigger: "blur" }],
        querenpassw: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
      uploadFileUrl: process.env.VUE_APP_BASE_API + "/upload/uploadOther", // 上传的图片服务器地址
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
  },
  components: {
    userAvatar,
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", null);
    this.infoData();
    this.zygetList();
  },
  mounted() {},
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    // 个人信息
    infoData() {
      getInfos().then((res) => {
        this.form = res.user;
        this.getClassList({ subjectId: this.form.subjectId });
      });
    },
    handleAvatarSuccess(res, file) {
      this.form.avatar = res.data;
    },
    beforeAvatarUpload(file) {},
    /** 查询院系专业列表 */
    zygetList() {
      listSubject().then((response) => {
        this.subjectList = response.rows;
      });
    },
    //** 查询班级列表 */
    getClassList(id) {
      listClass(id).then((response) => {
        this.classList = response.rows;
      });
    },
    //选择专业
    zychangeSel(e) {
      this.form.subjectId = e;
      this.form.classId = "";
      this.getClassList({ subjectId: this.form.subjectId });
    },
    // 保存
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updataInfops();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updataInfops() {
      updateInfo(this.form).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.infoData();
          this.$store.dispatch("user/getInfo");
        }
      });
    },
    // 修改密码
    submitFormpsw(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updatapwdBtn();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.updatashow = !this.updatashow;
    },
    updatapwdBtn() {
      let data = {
        oldPassword: this.ruleFormPsw.oldPassword,
        newPassword: this.ruleFormPsw.newPassword,
      };
      let formobj = new window.FormData();
      formobj.append("oldPassword", this.ruleFormPsw.oldPassword);
      formobj.append("newPassword", this.ruleFormPsw.newPassword);
      updatePwd(formobj).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "修改成功,请重新登录",
            type: "success",
          });
          this.handleLogout();
        }
      });
    },
    handleLogout() {
      this.$store.dispatch("user/logout").then(() => {
        if (this.$route.fullPath !== "/home") {
          this.$router.push({ path: "/" });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.mysetup {
  width: 100%;
  min-height: 800px;
  background-color: #f7f7f7;
  overflow: hidden;
  .mysetup_center {
    width: 1200px;
    min-height: 800px;
    margin: 30px auto;
    padding: 30px;
    background-color: #ffffff;
    .el-menu-demo {
      .tabcolor {
        color: #ffffff;
      }
    }
    .ziliao_setup {
      margin-top: 40px;
      h4 {
        font-size: 16px;
        font-weight: bold;
        color: #1d4434;
        padding: 15px 0;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }

      .avatar {
        width: 178px;
        height: 178px;
        border-radius: 50%;
        display: block;
      }
      .onsubtns {
        text-align: center;
        .el-button {
          background-color: #1d4434;
          color: #ffffff;
        }
      }
    }
    // 账号设置
    .psw_setup {
      margin-top: 40px;
      .psw_p1 {
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        .p2 {
          line-height: 20px;
        }
      }
      .updatapsw {
        font-size: 14px;
        font-weight: 400;
        color: #1d4434;
        cursor: pointer;
      }
      .updatapas_inpts {
        width: 210px;
        margin-top: -20px;
        .el-input {
          margin-top: 20px;
        }
      }
      .updatabtnAll {
        width: 200px;
        margin: 20px 0 0 15px;
        .btn2 {
          margin-left: 30px;
          color: #1d4434;
          border: 1px solid #1d4434;
        }
      }
      .loginUp {
        margin-top: 100px;
        .elbtns {
          margin-left: 350px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.mysetup_center {
  .el-menu--horizontal > .el-menu-item.is-active {
    font-weight: bold;
    border-bottom: 2px solid #1d4434 !important;
  }
}
</style>
